<template>
    <div class="base-phone" :class="{'phone-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">{{title}}</div>
            <div v-show="next == true">
                <div class="tips">手机号可作为登录账号，也可通过已绑定的手机号码找回密码。</div>
                <input class="value" onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" type="text" maxlength="11" placeholder="请输入新手机号" v-model="phones" />
                <div class="val-box">
                    <input class="phonecode" type="text" maxlength="6" placeholder="请输入验证码" v-model="codes" />
                    <div class="code" @click="getCode(2)" v-if="iscode == false">获取验证码</div>
                    <div class="code" v-if="iscode == true">{{count}}s</div>
                </div>
            </div>
            <div v-show="next == false">
                <div class="tips">为了您的账号安全，需验证已绑定的手机{{phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')}}</div>
                <div class="val-box">
                    <input class="phonecode" type="text" maxlength="6" placeholder="请输入验证码" v-model="code" />
                    <div class="code" @click="getCode(6)" v-if="iscode == false">获取验证码</div>
                    <div class="code" v-if="iscode == true">{{count}}s</div>
                </div>
            </div>
            <div class="btn">
                <div class="item" @click="onOut">暂不修改</div>
                <div class="item" @click='onClick'>{{text}}</div>
            </div>
            <transition name="component-fade" mode="out-in">
                <TheTips :msg='msg' v-if="msg" />
            </transition>
        </div>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        components: {
            TheTips
        },
        props: {
            activeInfo: Number,
            phone: String
        },
        data () {
            return {
                msg: null,
                title: '验证手机号',
                next: false,
                text: '下一步',
                phones: '',
                iscode: false,
                count: 59,
                accountData: {},
                code: '',
                codes: ''
            }
        },
        watch: {
            activeInfo () {
                if (this.activeInfo == 1) {
                    this.iscode = false
                    this.title = '验证手机号'
                    this.next = false
                    this.text = '下一步'
                }
            }
        },
        methods: {
            // 获取手机验证码
            getCode (id) {
                if (this.iscode == true) {
                    return false
                }
                if (this.text == '确认修改') {
                    if (!this.phones.replace(/\s*/g, "")) {
                        return false
                    }
                }
                let reg = /^1[0-9]{10}$/
                if ((this.phones.length == 11 && reg.test(this.phones)) || this.phone) {
                    let phone = this.phones ? this.phones : this.phone
                    let options = {
                        appid: this.accountData.appid, //应用ID
                        mobile: phone,
                        type: id //1 注册 2绑定 3解绑 4 找回密码 6 换绑
                    };
                    options.sign = this.util.getSign(options, this.accountData.appkey);
                    this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=send_message', this.$qs.stringify(options)).then(res => {
                        if (res.data.status == 1) {
                            this.iscode = true
                            this.count = 59
                            let time = setInterval(() => {
                                this.count--
                                if (this.count == 0) {
                                    clearInterval(time)
                                    this.iscode = false
                                }
                            }, 1000)

                            this.msg = '验证码已发送'
                            setTimeout(() => {
                                this.msg = null
                            }, 1000)
                        } else {
                            this.msg = res.data.msg
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    }).
                    catch(o => {
                        this.msg = '请求失败'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    })
                } else {
                    this.msg = '手机号格式不正确'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                }
            },
            // 关闭弹窗
            onOut () {
                this.$emit('childPhone', null)
            },
            onClick () {
                if (this.phones) {
                    if (this.codes.replace(/\s*/g, "")) {
                        this.changePhone()
                    } else {
                        this.msg = '请输入验证码'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                } else {
                    if (this.code.replace(/\s*/g, "")) {
                        this.verifyPhone()
                    } else {
                        this.msg = '请输入验证码'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }
            },
            // 验证手机号
            verifyPhone () {
                let options = {
                    uid: this.accountData.uid,
                    mobile: this.phone,
                    appid: this.accountData.appid, //应用ID
                    code: this.code
                };
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=mobile_verify', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.iscode = false
                        this.phones = ''
                        this.title = '更换绑定手机号'
                        this.next = true
                        this.text = '确认修改'
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            // 换绑手机号
            changePhone () {
                let options = {
                    uid: this.accountData.uid,
                    mobile: this.phones,
                    old_mobile: this.phone,
                    appid: this.accountData.appid, //应用ID
                    code: this.codes
                };
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=change_mobile', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.msg = '修改成功'
                        setTimeout(() => {
                            this.msg = null
                            this.$emit('childPhone', null)
                        }, 1000)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-phone {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .tips {
                font-size: 42px;
                margin-bottom: 50px;
            }
            .value {
                width: 100%;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border: 0;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                margin-bottom: 30px;
                outline: none;
            }
            .val-box {
                width: 100%;
                height: 120px;
                color: #fff;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                display: flex;
                align-items: center;
                .phonecode {
                    width: 477px;
                    height: 48px;
                    color: #fff;
                    font-size: 39px;
                    border: 0;
                    border-right: 3px solid #fff;
                    border-radius: 18px 0 0 18px;
                    background: transparent;
                    padding: 0 45px;
                    outline: none;
                }
                .code {
                    flex: 1;
                    font-size: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            input::-webkit-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-moz-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-ms-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-o-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    // 竖屏css
    .phone-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .tips {
                font-size: 76px;
                margin-bottom: 90px;
            }
            .value {
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                padding: 0 81px;
                margin-bottom: 54px;
            }
            .val-box {
                height: 200px;
                border-radius: 32px;
                .phonecode {
                    width: 867px;
                    height: 87px;
                    font-size: 70px;
                    border-right: 5px solid #fff;
                    border-radius: 32px 0 0 32px;
                    padding: 0 81px;
                }
                .code {
                    font-size: 65px;
                }
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    width: 627px;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
        }
    }
</style>